// Footer.js
import React from "react";
import { Link } from "react-router-dom";

const Footer = () => {
  return (
    <footer className="bg-white">
      <div className="relative overflow-hidden min-h-[300px] md:min-h-[340px]">
        <div className="mx-3 md:mx-10 lg:mx-16 pt-16 pb-56 relative z-10">
          <div className="max-w-6xl mx-auto">
            <div className="flex flex-col md:flex-row md:items-start md:justify-between gap-10">
              <div className="md:w-[320px]">
              <h4 className="text-sm font-inter font-semibold text-acBlack">Vali Courses</h4>
              <div className="mt-4 text-sm text-gray-600 font-inter space-y-2">
                {/* <div>+234 707 255 9063</div> */}
                <div>Email: info@valicourses.com</div>
                {/* <div>Phone: +1 (555) 123-4567</div> */}
              </div>
              </div>

              <div className="flex flex-col sm:flex-row gap-12 md:gap-24">
                <div>
                  <h4 className="text-sm font-inter font-semibold text-acBlack">Company</h4>
                  <ul className="mt-4 space-y-2 text-sm font-inter text-gray-600">
                    <li>
                      <Link to="/" className="hover:text-acBlack transition-colors">
                        Home
                      </Link>
                    </li>
                    <li>
                      <Link to="/contact" className="hover:text-acBlack transition-colors">
                        Contact
                      </Link>
                    </li>
                  </ul>
                </div>

                <div>
                  <h4 className="text-sm font-inter font-semibold text-acBlack">Product</h4>
                  <ul className="mt-4 space-y-2 text-sm font-inter text-gray-600">
                    <li>
                      <Link to="/#courses" className="hover:text-acBlack transition-colors">
                        Courses
                      </Link>
                    </li>
                    <li>
                      <Link to="/terms-of-service" className="hover:text-acBlack transition-colors">
                        Term &amp; Conditions
                      </Link>
                    </li>
                    <li>
                      <Link to="/privacy-policy" className="hover:text-acBlack transition-colors">
                        Privacy Policy
                      </Link>
                    </li>
                  </ul>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div className="pointer-events-none absolute inset-x-0 bottom-0 flex justify-center z-0">
          <div className="translate-y-10 md:translate-y-14 text-[96px] sm:text-[140px] md:text-[200px] lg:text-[260px] font-inter font-black tracking-tight text-gray-200/60 select-none whitespace-nowrap leading-none">
            Vali Courses
          </div>
        </div>

        <div className="absolute inset-x-0 bottom-8 md:bottom-10 z-10">
          <div className="mx-3 md:mx-10 lg:mx-16">
            <div className="max-w-6xl mx-auto">
              <div className="text-center text-xs md:text-sm text-gray-600 font-inter">
                <div>© {new Date().getFullYear()} Validate Systems. All rights reserved.</div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
